<template>
	<v-container fluid>
		<v-row>
			<v-col cols="12" lg="12" class="pb-0 pt-0">
				<v-card flat>
					<v-card-text class="pb-0 pt-2">
						<v-row class="pb-1">
							<v-col class="d-flex justify-start pa-0 pl-2">
								<v-btn color="primary" @click="addClick">
									<v-icon small>fa-plus</v-icon>&nbsp;&nbsp;{{ $t('buttons.add') }}
								</v-btn>
							</v-col>
							<v-col class="d-flex justify-center pb-0 pt-0">
								<v-card-title class="text-center pa-2 pb-2 pt-0">
									{{ $t('modules.contracts') }}</v-card-title
								>
							</v-col>
							<v-col></v-col>
						</v-row>
						<v-row>
							<v-col class="pb-0 pt-0">
								<TheTable
									:additional-filters="contractsTable.additionalFilters"
									:default-sort="contractsTable.defaultSort"
									:excel="true"
									:fields="contractsTable.headers"
									:header-selection-key="'contracts-headers'"
									:height="contractsTable.height"
									:total-records="contractsTable.total"
									:filter-save-key="'contracts-filters'"
									@excel="excelExport"
									@headers="selectHeaders"
									@reload="reloadData"
								>
									<tr
										v-for="(item, key) in contractsTable.items"
										:key="key"
										:class="{ 'cursor-pointer': true }"
										@contextmenu.prevent="editClick(props.item.id, true)"
									>
										<td
											v-if="contractsTable.selectedHeaders.includes('contract_number')"
											@click="editClick(item.id, false)"
										>
											{{ item.contract_number }}
										</td>
										<td
											v-if="contractsTable.selectedHeaders.includes('start_date')"
											@click="editClick(item.id, false)"
										>
											{{
												item.start_date != null
													? item.start_date.split('-').reverse().join('.')
													: ''
											}}
										</td>
										<td
											v-if="contractsTable.selectedHeaders.includes('end_date')"
											@click="editClick(item.id, false)"
										>
											{{
												item.end_date != null
													? item.end_date.split('-').reverse().join('.')
													: ''
											}}
										</td>
										<td
											v-if="contractsTable.selectedHeaders.includes('contract_type_id')"
											@click="editClick(item.id, false)"
										>
											{{ item.contract_type.name }}
										</td>
										<td
											v-if="contractsTable.selectedHeaders.includes('teacher_id')"
											@click="editClick(item.id, false)"
										>
											<b>{{ item.teacher.full_name }}</b>
										</td>
										<td
											v-if="contractsTable.selectedHeaders.includes('author_id')"
											@click="editClick(item.id, false)"
										>
											{{ item.author.full_name }}
										</td>
										<td>
											<v-tooltip bottom>
												<template v-slot:activator="{ on, attrs }">
													<v-btn
														icon
														small
														v-bind="attrs"
														@click="editClick(item.id, true)"
														v-on="on"
													>
														<v-icon small>fa-external-link-alt</v-icon>
													</v-btn>
												</template>
												<span>{{ $t('tooltips.openInNewTab') }}</span>
											</v-tooltip>
										</td>
									</tr>
								</TheTable>
							</v-col>
						</v-row>
					</v-card-text>
				</v-card>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
import TheTable from '../../trinkets/TheTable';

export default {
	name: 'Contracts',
	components: { TheTable },
	data: function () {
		return {
			contractsTable: {
				selectedHeaders: [],
				headers: [
					{
						text: this.$t('fields.contractNumber'),
						value: 'contract_number',
						type: 'string',
						width: '150px',
						allowFilter: true,
					},
					{ text: this.$t('fields.startDate'), value: 'start_date', type: '', allowFilter: true },
					{ text: this.$t('fields.endDate'), value: 'end_date', type: '', allowFilter: true },
					{
						text: this.$t('fields.contractType'),
						value: 'contract_type_id',
						type: 'dropdown|contract-types',
						allowFilter: true,
					},
					{
						text: this.$t('fields.teacher'),
						value: 'teacher_id',
						type: 'dropdown|teachers',
						allowFilter: true,
					},
					{ text: this.$t('fields.created'), value: 'author_id', type: 'dropdown|users', allowFilter: true },

					{ text: '', value: 'actions', type: '', sortable: false, width: '100px', allowFilter: false },
				],
				additionalFilters: [
					{ text: this.$t('fields.startDate'), value: 'start_date', type: 'date_range' },
					{ text: this.$t('fields.endDate'), value: 'end_date', type: 'date_range' },
				],
				items: [],
				total: 0,
				lastRequest: null,
				height: '0px',
				defaultSort: {
					field: 'start_date',
					descending: true,
				},
			},
		};
	},
	methods: {
		addClick() {
			this.$router.push('/contracts/0');
		},
		editClick(id, newTab = false) {
			if (!newTab) {
				this.$router.push('/contracts/' + id);
			} else {
				let routeData = this.$router.resolve('/contracts/' + id);
				window.open(routeData.href, '_blank');
			}
		},
		selectHeaders(headers) {
			this.contractsTable.selectedHeaders = headers;
		},
		reloadData(request) {
			this.contractsTable.lastRequest = request;
			let vm = this;
			this.$APICall(
				'get',
				'contracts',
				request,
				(data, success) => {
					if (success) {
						vm.contractsTable.items = data.items;
						vm.contractsTable.total = data.total;
					} else {
						vm.$alert(vm.$t('alerts.basicError'));
					}
				},
				false
			);
		},
		excelExport() {
			let excelRequest = JSON.parse(JSON.stringify(this.contractsTable.lastRequest));
			excelRequest.pagination.itemsPerPage = 999999999;
			excelRequest.pagination.page = 1;

			let vm = this;
			this.$APICall(
				'get',
				'contracts',
				excelRequest,
				(data, success) => {
					if (success) {
						vm.$APICall('post', 'excel/contracts', data.items, (data, success) => {
							window.open(data.link);
						});
					} else {
						vm.$alert(vm.$t('alerts.basicError'));
					}
				},
				false
			);
		},
		resolveWindowResize() {
			this.contractsTable.height = window.innerHeight - 243 + 'px';
		},
	},
	mounted() {
		if (!this.$myStore.state.loggedIn) {
			this.$router.replace('/login');
		}
		if (this.$myStore.state.user.user_role_id == 2) {
			this.$router.replace('/candidates');
		}
		this.$myStore.commit('setBreadcrumbs', [
			{ text: this.$t('modules.contracts'), href: '/#/contracts', disabled: true },
		]);

		window.addEventListener('resize', this.resolveWindowResize);
		this.resolveWindowResize();
	},
};
</script>

<style scoped></style>
